// Any area specific things which need to exist at application startup can be imported here.
import "./infrastructure/startup";
import "./library/startup";
import "../components/startup";